import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { White, Primary500, Gray200, Gray300 } from '@mehilainen/mds-customer/colors'
import { spacing } from '@mehilainen/mds-tokens/spacing'

import { BaseTileBoxShadow } from '../../../constants'
import { breakpoint } from '../../utils/breakpoint'
import { scale } from '../../utils/scale'
import { Text } from '../Typography/Typography'

export const BaseTile = styled.li<{ skeleton?: boolean; minHeight?: string }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${spacing[200].rem};
  background: ${White};
  cursor: pointer;
  position: relative;

  @media (min-width: ${breakpoint.sm}px) {
    border: 2px solid ${White};
    border-radius: ${scale(1)};
    box-shadow: ${BaseTileBoxShadow};

    &:hover {
      border-color: ${Gray300};
    }

    &:focus {
      border-color: ${Primary500};
    }
  }

  ${(props) =>
    props.skeleton &&
    css`
      min-height: ${props.minHeight ? props.minHeight : '100px'};
      background: ${Gray200};
    `}
`
export const MobileBaseTile = styled(BaseTile)<{ highPadding: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing[200].rem};
  padding: ${spacing[400].rem} ${spacing[500].rem};
  padding-bottom: ${(props) => (props.highPadding ? spacing[700].rem : spacing[400].rem)};
`

const gridTemplateCSS = (columns: string) => css`
  display: grid;
  grid-template-columns: ${columns};
  gap: 0.375rem;

  @media (min-width: ${breakpoint.md}px) and (max-width: ${breakpoint.lg}px) {
    grid-template-columns: ${columns
      .replace(/6.25rem|9.375rem/, '5rem')
      .replace(/4.6875rem/, '4.6875rem/')};
  }
`

export const ThreeColumnGrid = gridTemplateCSS('6.25rem 1fr auto')
export const FourColumnGrid = gridTemplateCSS('6.25rem 1fr 1fr auto')
export const CallbackColumnGrid = gridTemplateCSS('6.25rem 1fr 1fr auto')
export const FourColumnGridWithInfoText = gridTemplateCSS('6.25rem 1.5fr 1fr auto')

export const SpecialistTilesContainer = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${spacing[200].rem};

  @media (max-width: ${breakpoint.sm}px) {
    margin: 0 -${spacing[500].rem};
  }

  @media (min-width: ${breakpoint.sm + 1}px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`

export const TimeslotTilesContainer = styled.ul`
  display: flex;
  flex-direction: column;
  max-width: 100vw;

  @media (max-width: ${breakpoint.sm}px) {
    margin: 0 -${spacing[500].rem};
    gap: ${spacing[100].rem};
  }

  @media (min-width: ${breakpoint.sm}px) {
    gap: ${spacing[200].rem};
  }

  ${MobileBaseTile} {
    @media (min-width: ${breakpoint.sm}px) {
      margin-top: ${spacing[300].rem};
    }
  }
`

export const ClickableText = styled(Text)<{ clickable?: boolean }>`
  ${({ clickable }) =>
    clickable &&
    `
    &:hover {
      text-decoration: underline;
    }
  `}
`
